// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Yea5m","label":"LabeledBox_label__d5CY8"};